import React from 'react';

import {
  STRING_JANUARY,
  STRING_FEBRUARY,
  STRING_MARCH,
  STRING_APRIL,
  STRING_MAY,
  STRING_JUNE,
  STRING_JULY,
  STRING_AUGUST,
  STRING_SEPTEMBER,
  STRING_OCTOBER,
  STRING_NOVEMBER,
  STRING_DECEMBER,
} from '../labels';

const monthMap = {
  [STRING_JANUARY]: 1,
  [STRING_FEBRUARY]: 2,
  [STRING_MARCH]: 3,
  [STRING_APRIL]: 4,
  [STRING_MAY]: 5,
  [STRING_JUNE]: 6,
  [STRING_JULY]: 7,
  [STRING_AUGUST]: 8,
  [STRING_SEPTEMBER]: 9,
  [STRING_OCTOBER]: 10,
  [STRING_NOVEMBER]: 11,
  [STRING_DECEMBER]: 12,
};

export const numsToMonths = {
  1: STRING_JANUARY,
  2: STRING_FEBRUARY,
  3: STRING_MARCH,
  4: STRING_APRIL,
  5: STRING_MAY,
  6: STRING_JUNE,
  7: STRING_JULY,
  8: STRING_AUGUST,
  9: STRING_SEPTEMBER,
  10: STRING_OCTOBER,
  11: STRING_NOVEMBER,
  12: STRING_DECEMBER,
};

export default function MonthOptions() {
  return (
    <>
      {Object.entries(monthMap)
        .map(([display, value]) => <option key={value} value={value}>{display}</option>)}
    </>
  );
}
